import {
  useUpdateAccountSetting,
  useGetAccountSetting,
  AccountWidgetSetting,
} from "@shortsworks/user-api";
import FormContainer from "src/components/forms/container/FormContainer";
import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import { WidgetSettingsSchema } from "@app/pages/widget/Settings/widgetSettingsSchema";
import {
  Button,
  useModal,
  defaultGradientColor,
  GradientColor,
} from "@shortsworks/ui";
import { MainContentContainer } from "@app/components/MainContainer";
import { MainHeader } from "@app/components/MainContainer/MainHeader";
import { MainContent } from "@app/components/MainContainer/MainContent";
import { MainTitle } from "@app/components/MainContainer/MainTitle";
import { MainDescription } from "@app/components/MainContainer/MainDescription";
import { useQueryClient } from "@tanstack/react-query";
import { Fragment, useEffect, useState } from "react";
import { LoaderCircle } from "lucide-react";
import { CommonModal } from "@app/components/modals/CommonModal";
import { CommonErrorModal } from "@app/components/modals/CommonErrorModal";

// 기존의 값을 받아와서 그려오도록 관리 필요(컬러 픽커 컴포넌트 값에 따라 그려지도록 관리 필요)
export const Settings = () => {
  const {showModal} = useModal();
  const queryClient = useQueryClient();
  const {
    data: accountSettingData,
    isSuccess: isSuccessGetAccountSettings,
    queryKey: accountSettingQueryKey,
  } = useGetAccountSetting();
  const {mutateAsync: mutateAsyncUpdateAccountSetting} =
      useUpdateAccountSetting({
        mutation: {
          onSuccess: () => {
            // return queryClient.invalidateQueries({queryKey: accountSettingQueryKey});
          },
        },
      });

  const {form, schemas, zodSchema, parseForm, formValues, setFormValues} =
      useFormWithSchema({
        formSchemas: WidgetSettingsSchema,
        mode: "onChange",
        defaultFormValues: {
          storyBorderColor: defaultGradientColor(),
          shortsBorderColor: defaultGradientColor()
        }
      });

  const handleSave = async () => {
    const parsedForm = parseForm();
    if (!parsedForm.success) {
      return showModal(CommonErrorModal, {
        title: "위젯 설정 변경에 실패했습니다.",
      });
    }

    // 중복되는 부분 수정, 문자열로 변환
    const storyBorderColorGradient = parsedForm.data.storyBorderColor;
    const storyBorderColor = GradientColor.new(
        storyBorderColorGradient.type,
        storyBorderColorGradient.colorStops,
        storyBorderColorGradient.angle,
    ).toCss();

    const shortsBorderColorGradient = parsedForm.data.shortsBorderColor;
    const shortsBorderColor = GradientColor.new(
        shortsBorderColorGradient.type,
        shortsBorderColorGradient.colorStops,
        shortsBorderColorGradient.angle,
    ).toCss();

    try {
      const updateAccountSettingResult = await mutateAsyncUpdateAccountSetting({
        data: {
          ...parsedForm.data,
          // @ts-ignore
          widgetStartColor:
              accountSettingData?.data.widgetStartColor?.toString(),
          // @ts-ignore
          widgetEndColor: accountSettingData?.data.widgetEndColor?.toString(),
          // useRestrictGuest params가 있도록 변경 필요
          restrictGuest: parsedForm.data.useRestrictGuest
              ? parsedForm.data.restrictGuest
              : null,
          storyBorderColor,
          shortsBorderColor,
        },
      });

      if (!updateAccountSettingResult.data.success) {
        return showModal(CommonErrorModal, {
          title: "위젯 설정 변경에 실패했습니다.",
        });
      }
      return showModal(CommonModal, {title: "위젯 설정이 변경되었습니다."});
    } catch (error) {
      return showModal(CommonErrorModal, {
        title: "위젯 설정 변경에 실패했습니다.",
      });
    }
  };

  // 처음 노출 시 저장된 전체 데이터 호출
  useEffect(() => {
    if (!isSuccessGetAccountSettings) {
      return;
    }

    // 일부 데이터 변환 필요
    return setFormValues({
      ...accountSettingData.data,
      // string, number 타입 문제 체크 필요(FormField.Number)
      // @ts-ignore
      imagePreviewDuration:
          accountSettingData?.data.imagePreviewDuration?.toString(),
      videoPreviewDuration:
          accountSettingData?.data.videoPreviewDuration?.toString(),
      restrictGuest: accountSettingData?.data.restrictGuest?.toString(),
      useRestrictGuest: accountSettingData?.data.restrictGuest !== 0,
      storyBorderColor: GradientColor.fromCss(
          // @ts-ignore
          accountSettingData.data.storyBorderColor,
      ),
      shortsBorderColor: GradientColor.fromCss(
          // @ts-ignore
          accountSettingData.data.shortsBorderColor,
      ),
    });
  }, [isSuccessGetAccountSettings]);

  {
    // 전체 로딩으로 통일 필요
    if (!isSuccessGetAccountSettings) {
      return (
          <div className="w-full h-full flex items-center justify-center">
            <LoaderCircle className="w-6 h-6 mr-2 animate-spin"/>
          </div>
      );
    }

    return (
        <MainContentContainer>
          <MainHeader>
            <MainTitle>위젯 설정</MainTitle>
            <MainDescription>
              위젯의 기본적인 설정을 할 수 있습니다. 위젯 스튜디오에서 각 위젯의
              추가적인 설정을 할 수 있습니다.
            </MainDescription>
          </MainHeader>
          <MainContent>
            {
              isSuccessGetAccountSettings && (
                <div className="max-w-7xl">
                  <FormContainer form={form} schemas={schemas}/>
                  <Button className="w-full md:w-1/4 mt-8" onClick={handleSave}>
                    저장
                  </Button>
                </div>
            )}
          </MainContent>
        </MainContentContainer>
    );
  }
}
